/**
 * MobileNotAvailable Component
 * 
 * Displays a friendly message when users try to access desktop-only pages on mobile
 * Provides clear instructions to use desktop version
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faArrowLeft, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './MobileNotAvailable.css';

const MobileNotAvailable = ({ title = "Page Not Available", icon = faExclamationTriangle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    navigate('/mobile');
  };

  return (
    <div className="mobile-not-available">
      <div className="mobile-not-available-content">
        <div className="mobile-not-available-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        
        <h2 className="mobile-not-available-title">{title}</h2>
        
        <div className="mobile-not-available-message">
          <p>The page <strong>{location.pathname}</strong> is not available on mobile devices.</p>
          <p>Please use your desktop or laptop computer to access this content.</p>
        </div>

        <div className="mobile-not-available-desktop-icon">
          <FontAwesomeIcon icon={faDesktop} />
          <span>Desktop Required</span>
        </div>

        <div className="mobile-not-available-actions">
          <button 
            className="mobile-not-available-btn mobile-not-available-btn-primary"
            onClick={handleGoBack}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            Back to Mobile Home
          </button>
        </div>

        <div className="mobile-not-available-footer">
          <p>Thank you for understanding!</p>
        </div>
      </div>
    </div>
  );
};

export default MobileNotAvailable; 